module.exports = __webpack_public_path__ + "img/Doc14c_20030023-256_24.fe4ca5e7.jpg";